import { render, staticRenderFns } from "./educationInfo.vue?vue&type=template&id=170013e6&scoped=true"
import script from "./educationInfo.vue?vue&type=script&lang=js"
export * from "./educationInfo.vue?vue&type=script&lang=js"
import style0 from "./educationInfo.vue?vue&type=style&index=0&id=170013e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170013e6",
  null
  
)

export default component.exports